import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Card } from "@/components/Primitives";
import { BRANDING } from "@/config/branding";
import { Construction, ArrowRight } from "lucide-react";

export default function ComingSoon({ title }) {
  const { entitlements } = useAuth();
  const navigate = useNavigate();
  return (
    <div>
      <PageHeader title={title} subtitle="Part of your Financial Home — arriving soon." />
      <Card className="text-center py-16" data-testid="coming-soon">
        <div className="w-16 h-16 rounded-full bg-[#F0E7D8] flex items-center justify-center mx-auto mb-5">
          <Construction size={26} className="text-[#C6A45C]" strokeWidth={1.4} />
        </div>
        <h2 className="font-display text-2xl font-light text-[#2C2A28] mb-2">{title} is being prepared</h2>
        <p className="text-[#8A7F70] text-sm max-w-md mx-auto">
          This room is included in your <span className="gold-text font-medium">{entitlements?.tier_name}</span> plan
          and is rolling out in an upcoming {BRANDING.name} release. We're building it with the same calm and care as the rest of your home.
        </p>
        <button onClick={() => navigate("/")} className="mt-6 inline-flex items-center gap-2 gold-text text-sm hover:gap-3 transition-all" data-testid="coming-soon-home">
          Back to Home <ArrowRight size={16} />
        </button>
      </Card>
    </div>
  );
}
